import Breadcrumbs from '@components/Breadcrumbs';
import Container from '@components/UI/Container';
import Link from '@components/UI/Link';
import Heading from '@components/UI/Typography/Heading';
import Paragraph from '@components/UI/Typography/Paragraph';

import { Navigation } from "@layouts/NavigationV2"

import React from 'react';

const TermsofUse = () => (
    <>
        <Navigation
            staticTheme="light"
            actionTheme="light"
        />

        <Breadcrumbs
            wrap
        />

        <div
            className='legal'
        >
            <Container>
                <Heading
                    tag='h1'
                >
                    Terms of Use
                </Heading>

                <Paragraph
                    tag='p'
                >
                    PLEASE READ THIS DOCUMENT CAREFULLY. PERMISSION TO USE THIS SOFTWARE AND SERVICE IS CONDITIONAL ON YOU AGREEING TO THE TERMS HEREIN.
                </Paragraph>

                <Heading
                    tag='h3'
                >
                    BACKGROUND:
                </Heading>
                <ol>
                    <li>
                        <strong>a.</strong> A reference in these Terms to the "Service" means the Traqq time tracking application and the service provided through the <Link target='_blank' mods={ { violet: true } } href='https://traqq.com/'>traqq.com</Link> website and the user account interface available thereon; a reference to the "Documentation" includes any documentation provided by Traqq to use the software and service.
                    </li>
                    <li>
                        <strong>b.</strong> You wish to use the Service.
                    </li>
                    <li>
                        <strong>c.</strong> Traqq Pty Ltd. ("Traqq") grants you a non-transferable non-exclusive license to use the Service on the terms and conditions specified in these Terms.
                    </li>
                </ol>

                <Heading
                    tag='h3'
                >
                    TERMS AND CONDITIONS:
                </Heading>

                <Heading
                    tag='h4'
                >
                    1. LICENSE
                </Heading>

                <ul>
                    <li>
                        <strong>1.1</strong> In consideration of the payment by you of the applicable fee indicated on Traqq’s website (unless the Service or a version thereof is free of charge, which will also be indicated) in respect of the Service (the "Fee") Traqq grants to you a non-exclusive and non-transferable license to:
                        <ol>
                            <li>
                                <strong>a.</strong> install the software and use the Service and Documentation for your own personal or internal business purposes subject to the conditions specified in these Terms;
                            </li>
                            <li>
                                <strong>b.</strong> use the Service and Documentation strictly in accordance with the provisions of these Terms and any documentation provided by Traqq for that purpose;
                            </li>
                            <li>
                                <strong>c.</strong> register only ONE (1) Traqq account for your company/team/organization. Only one organization may be registered from one IP address. Registering more than one account for the same company or from the same IP address will result in a ban.
                            </li>
                        </ol>
                    </li>
                    <Paragraph
                        tag='p'
                    >
                        Traqq reserves all rights not expressly granted to you in these Terms:
                    </Paragraph>
                    <li>
                        <strong>1.2</strong> The Service licensed to you may be used by you and people authorized by you.
                    </li>
                    <li>
                        <strong>1.3</strong> You undertake
                        <ol>
                            <li>
                                <strong>a.</strong> to supervise and control the use of the Service in accordance with these Terms;
                            </li>
                            <li>
                                <strong>b.</strong> to ensure that (if applicable) your employees, sub-contractors and other agents who have authorized access to the Service are made aware of the terms of, and comply with, these Terms;
                            </li>
                            <li>
                                <strong>c.</strong> and to not provide or otherwise make available the Service in any form to any person other than as permitted in these Terms.
                            </li>
                        </ol>
                    </li>
                    <li>
                        <strong>1.4</strong> Traqq application incorporates automatic processes during upgrades, i.e. the application displays a popup window to initiate an upgrade and installs it without showing prompts. This feature is provided as a convenient option for administrators who often prefer to deploy applications within corporate environments without requiring user interaction.
                    </li>
                    <li>
                        <strong>1.5</strong> Paid Service orders are processed by Traqq's online reseller Paddle. Paddle is the Merchant of Record for all Traqq orders. Paddle provides order-related customer service and handles returns.
                    </li>
                </ul>

                <Paragraph
                    tag='p'
                    id="fees-and-refunds"
                >
                    We use Paddle as a payment processing service, which allows Users to make online payments. When you make a purchase on traqq.com, you provide your data directly to Paddle, and your transaction is subject to <Link target='_blank' mods={ { violet: true } } href='https://www.paddle.com/legal/privacy'>Paddle Privacy Policy</Link>.
                    <br />Personal Data collected: various types of Data as specified in the privacy policy of the service.
                </Paragraph>

                <Heading
                    tag='h4'
                >
                    2. FEES AND REFUNDS
                </Heading>

                <ul>
                    <li>
                        <strong>2.1</strong> Traqq offers a 14-day free trial that allows you to test the Service at no charge, with no functionality limitations. Upon trial expiration, workspace owner have to select a subscription plan to continue using the Service.
                    </li>
                    <li>
                        <strong>2.2</strong> The License and Fee (if any) are exclusive of taxes, duties and charges imposed or levied in connection with the supply of the Service. Without limiting the foregoing, you shall be liable for any subsequent taxes, duties or charges in respect of the Service.
                    </li>
                    <li>
                        <strong>2.3</strong> Traqq offers a 14-day money-back guarantee on your first purchase. If this is your first paid subscription with Traqq, you may request a full refund within 14 days of the initial payment.
                    </li>
                </ul>

                <Paragraph
                    tag='p'
                >
                    If you choose to downgrade your Traqq plan, the downgrade will take effect immediately. Any unused portion of your payment resulting from the downgrade will be converted into account credits. These credits will be automatically applied toward your next payment or payments until the credit balance is fully used.
                    If you cancel your Traqq subscription, no further charges will be made after the cancellation takes effect. Except for refunds covered by the 14-day money-back guarantee or charges made due to a payment system error, payments are non-refundable.
                    A refund may also be issued in the event of an unintentional charge caused by a payment system error, provided that the error is identified and a refund is requested within 14 days of the charge.
                </Paragraph>

                <Heading
                    tag='h4'
                >
                    3. GOODS AND SERVICES TAX
                </Heading>

                <ul>
                    <li>
                        <strong>3.1</strong> All amounts payable or other consideration provided in respect of supplies made in relation to these Terms are exclusive of GST (if any). Where a supply is a taxable supply, all amounts payable or other consideration provided must be increased by the amount of GST payable in relation to the supply.
                    </li>
                    <li>
                        <strong>3.2</strong> All GST must be paid at the time any payment to which it relates is payable (provided a tax invoice has been issued for the supply). Where any GST payable is not referable to an actual payment, then it must be paid within ten (10) days of a tax invoice being issued by the supplier.
                    </li>
                    <li></li>
                </ul>

                <Heading
                    tag='h4'
                >
                    4. MODIFICATIONS
                </Heading>

                <ul>
                    <li>
                        <strong>4.1</strong> You must not modify or alter the Service or merge all or any part of the Service with any other software without Traqq’s written permission. If the Service is modified or altered:
                        <ol>
                            <li>
                                <strong>a.</strong> the costs associated with the modifications or alterations will be borne solely by you;
                            </li>
                            <li>
                                <strong>b.</strong> and you will fully indemnify Traqq against all liability, cost and expenses (including legal costs) which may be incurred by Traqq if such modifications or alterations infringe any intellectual property rights of a third person or otherwise cause Traqq to suffer loss, damages or expense.
                            </li>
                        </ol>
                    </li>
                </ul>

                <Heading
                    tag='h4'
                >
                    5. SECURITY
                </Heading>

                <ul>
                    <li>
                        <strong>5.1</strong> You are responsible for the use, supervision, management and control of the Service and Documentation.
                    </li>
                    <li>
                        <strong>5.2</strong> You must use reasonable endeavors to ensure that the Service is protected at all times from misuse, damage, destruction or any form of unauthorized use.
                    </li>
                    <li>
                        <strong>5.3</strong> You must keep accurate records of use, copying, modification and disclosure of the Service.
                    </li>
                    <li>
                        <strong>5.4</strong> Reports and related data are available for access no earlier than January 1 of the previous calendar year. Any data older than this period is automatically and permanently deleted for compliance and security reasons. Traqq does not guarantee access to reports older than the defined retention period.

                        <br />If access to older reports is required, the user is solely responsible for exporting and securely storing such reports in advance, in any format of their choice.
                    </li>
                </ul>

                <Heading
                    tag='h4'
                >
                    6. UPDATES AND NEW RELEASES
                </Heading>

                <ul>
                    <li>
                        <strong>6.1</strong> Traqq may in its sole discretion notify you from time to time of any update or new release of the Traqq application which provides functions equal to or better than the current version.
                    </li>
                    <li>
                        <strong>6.2</strong> Where an update or new release is provided by Traqq:
                        <ol>
                            <li>
                                <strong>a.</strong> you must immediately install the update or new release and Traqq is not liable for, and will (notwithstanding any other provision of these Terms) not accept any liability for any previous version or release.
                            </li>
                        </ol>
                    </li>
                </ul>

                <Heading
                    tag='h4'
                >
                    7. WARRANTIES
                </Heading>

                <ul>
                    <li>
                        <strong>7.1</strong> Traqq warrants that:
                        <ol>
                            <li>
                                <strong>a.</strong> it has authority to grant the rights granted in these Terms;
                            </li>
                            <li>
                                <strong>b.</strong> and the Service will operate in conformity with the Documentation in all material respects.
                            </li>
                        </ol>
                    </li>
                    <li>
                        <strong>7.2</strong> TRAQQ WILL NOT BE LIABLE UNDER THIS CLAUSE TO THE EXTENT THAT A DEFECT IS CAUSED BY YOUR USE OF THE SERVICE OTHER THAN IN ACCORDANCE WITH THESE TERMS, INCLUDING THE FAILURE BY YOU OR A THIRD PARTY TO MAINTAIN THE OPERATING ENVIRONMENT DESIGNATED IN THE DOCUMENTATION OR TO OTHERWISE USE THE SERVICE IN ACCORDANCE WITH ANY SPECIFICATIONS ISSUED BY TRAQQ.
                    </li>
                    <li>
                        <strong>7.3</strong> YOU ACKNOWLEDGE THAT THE SERVICE IS DISTRIBUTED AS IS AND TRAQQ IN NO WAY GUARANTEES THAT IT WILL OPERATE UNINTERRUPTED OR BE ERROR FREE. YOU ACKNOWLEDGE THAT THE EXISTENCE OF ANY ERRORS DOES NOT CONSTITUTE A BREACH OF THESE TERMS.
                    </li>
                    <li>
                        <strong>7.4</strong> YOU FURTHER ACKNOWLEDGE THAT GOOD DATA PROCESSING PROCEDURES DICTATE THAT ANY SOFTWARE BE THOROUGHLY TESTED WITH NON-CRITICAL DATA BEFORE RELYING ON IT. YOU ASSUME THE ENTIRE RISK OF USING THE SERVICE AND DOCUMENTATION. THIS DISCLAIMER OF WARRANTY CONSTITUTES AN ESSENTIAL PART OF THESE TERMS.
                    </li>
                    <li>
                        <strong>7.5</strong> YOU ACKNOWLEDGE THAT YOU HAVE EXERCISED YOUR INDEPENDENT JUDGEMENT IN OBTAINING THE SERVICE AND HAVE NOT RELIED ON ANY REPRESENTATION MADE BY TRAQQ WHICH HAS NOT BEEN STATED EXPRESSLY IN THESE TERMS OR UPON ANY DESCRIPTIONS OR ILLUSTRATIONS OR SPECIFICATIONS CONTAINED IN ANY DOCUMENT INCLUDING PUBLICITY MATERIAL PRODUCED BY TRAQQ.
                    </li>
                    <li>
                        <strong>7.6</strong> OTHER THAN IMPLIED BY LAW, THE WARRANTIES IN THIS CLAUSE REPRESENT ALL OF THE WARRANTIES GIVEN BY TRAQQ AND NO TERM OR WARRANTY WILL BE IMPLIED.
                    </li>
                </ul>

                <Heading
                    tag='h4'
                >
                    8. CONFIDENTIALITY
                </Heading>

                <ul>
                    <li>
                        <strong>8.1</strong> You may not, without the prior written approval of Traqq, disclose Traqq’s Confidential Information (as defined below).
                    </li>
                    <li>
                        <strong>8.2</strong> You must take all reasonable steps to ensure that your employees and agents, and any sub-contractors engaged for the purposes of these Terms, do not disclose Traqq’s Confidential Information.
                    </li>
                    <li>
                        <strong>8.3</strong> The Service uses Google Analytics to collect information to improve the products and features users use most often and to help solve problems. Google Analytics collects software and service usage data only. This information does not include any personally identifiable details.
                    </li>
                    <li>
                        <strong>8.4</strong> See <Link target='_blank' mods={ { violet: true } } href='https://traqq.com/legal/privacy'>Privacy Policy</Link> for more information on how we handle the data we collect. By accepting these <Link target='_blank' mods={ { violet: true } } href='https://traqq.com/legal/terms'>Terms</Link> and using the Service you confirm that you have also read and accepted the <Link target='_blank' mods={ { violet: true } } href='https://traqq.com/legal/privacy'>Privacy Policy</Link>, which forms part of these Terms.
                    </li>
                </ul>

                <Heading
                    tag='h4'
                >
                    9. INTELLECTUAL PROPERTY RIGHTS
                </Heading>

                <ul>
                    <li>
                        <strong>9.1</strong> You acknowledge that the Service and Documentation are the subject of intellectual property rights including copyright (the “Rights”). You shall not during or any time after the termination of the license based on these Terms permit any act (including without limitation copying the Service except as permitted in these Terms) which infringes those Rights. For the avoidance of doubt these Terms do not give you any right to use any trademarks of Traqq associated with the Service or Documentation. You will fully indemnify Traqq against all liability, cost and expenses (including legal costs) which may be incurred by Traqq as a result of your breach of the provisions of this clause.
                    </li>
                    <li>
                        <strong>9.2</strong> The Service may include a JSON serializer from Newtonsoft.Json, which is subject to the following terms: Copyright (c) 2007 James Newton-King Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions: The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. The term "Software" in section 9.2 refers solely to Newtonsoft.Json and is not to be confused with the same term used throughout the rest of this document.
                    </li>
                    <li>
                        <strong>9.3</strong> The Service may include the ConfuserEx software code, which is licensed under the MIT license and is subject to the following terms: Copyright (c) 2014 yck1509 Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
                        <br />The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
                        <br />THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. The term "Software" in section 9.3 refers solely to ConfuserEx and is not to be confused with the same term used throughout the rest of this document.
                    </li>
                    <li>
                        <strong>9.4</strong> The Service may include modified code from Inno Setup, which is subject to the following Copyright terms:
                        <br />Copyright (C) 1997-2016 Jordan Russell. All rights reserved.
                        <br />Portions Copyright (C) 2000-2016 MartijnLaan. All rights reserved.
                        <br />The updated terms and information for the Inno Setup component may be found on <Link href='http://www.jrsoftware.org' mods={ { violet: true } } target='_blank'>http://www.jrsoftware.org</Link>.
                    </li>
                    <li>
                        <strong>9.5</strong> The Service may include the SQLite library, the use of which is subject to the Microsoft Public license. Please see license terms here - <Link href='https://opensource.org/licenses/ms-pl' mods={ { violet: true } } target='_blank'>https://opensource.org/licenses/ms-pl</Link>.
                    </li>
                    <li>
                        <strong>9.6</strong> The Service may include libraries or modified code from <Link href='http://ffmpeg.org' mods={ { violet: true } } target='_blank'>FFmpeg</Link>, the use of which is subject to the <Link href='http://www.gnu.org/licenses/old-licenses/gpl-2.0.html' mods={ { violet: true } } target='_blank'>GNU General Public License (GPL) version 2</Link>.
                    </li>
                    <li>
                        <strong>9.7</strong> The Service may include the System.Windows.Interactivity library from Microsoft Expression Blend Service Development Kit (SDK) for .NET 4 subject to the terms available on Microsoft’s website at <Link href='https://www.microsoft.com/en-us/download/details.aspx?id=17718' mods={ { violet: true } } target='_blank'>https://www.microsoft.com/en-us/download/details.aspx?id=17718</Link>.
                    </li>
                    <li>
                        <strong>9.8</strong> The Service may include the Qt open-source framework and its libraries (Qt version 6.2.4 for Ubuntu 22 and 6.4.2 for other Linux OS versions) developed by Qt Group, its subsidiaries, and other contributors.
                        These libraries are licensed under the GNU Lesser General Public License (LGPL) and are subject to the terms available on the Qt Group website at <Link href='https://www.qt.io/' mods={ { violet: true } } target='_blank' linkProps={ { rel: 'nofollow' } }>https://www.qt.io/</Link>.
                        The full text of the LGPL can be found at <Link href='https://www.gnu.org/licenses/lgpl-3.0.html' mods={ { violet: true } } target='_blank' linkProps={ { rel: 'nofollow' } }>https://www.gnu.org/licenses/lgpl-3.0.html</Link>.
                    </li>
                    <li>
                        <strong>9.9</strong> The Service may include the Sparkle software update framework for macOS which is licensed under the MIT license and is subject to the following terms:
                        <br />Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
                        <br />The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
                        <br />THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. The term "Software" in section 9.7 refers solely to Sparkle and is not to be confused with the same term used throughout the rest of this document.
                    </li>
                </ul>

                <Heading
                    tag='h4'
                >
                    10. LIABILITY
                </Heading>

                <ul>
                    <li>
                        <strong>10.1</strong> SUBJECT TO CLAUSE 10.2, TRAQQ’S TOTAL LIABILITY TO YOU IN RESPECT OF ALL CLAIMS ARISING OUT OF OR IN ANY WAY RELATING TO THESE TERMS OR THE SERVICE INCLUDING CLAIMS UNDER ANY INDEMNITY OR FOR NEGLIGENCE SHALL BE STRICTLY LIMITED TO THE FEE PAID UNDER THESE TERMS.
                    </li>
                    <li>
                        <strong>10.2</strong> ANY DAMAGES RESULTING FROM A BREACH OF THESE TERMS BY EITHER PARTY ARE LIMITED TO ACTUAL DAMAGES INCURRED BY THE PARTY CLAIMING DAMAGES. NEITHER PARTY WILL BE LIABLE TO THE OTHER FOR ANY SPECIAL, INDIRECT, CONSEQUENTIAL OR INCIDENTAL LOSS OR DAMAGE INCLUDING BUT NOT LIMITED TO LOSS OF BUSINESS OPPORTUNITY, BUSINESS INTERRUPTION, LOST PROFITS OR FOR PUNITIVE OR EXEMPLARY DAMAGES EVEN IF TRAQQ HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
                    </li>
                    <li>
                        <strong>10.3</strong> IF ANY CONDITION OR WARRANTY IS IMPLIED INTO THESE TERMS BY LAW AND CANNOT BE EXCLUDED, THE LIABILITY OF TRAQQ FOR BREACH OF THE CONDITION OR WARRANTY IS LIMITED TO ONE OR MORE OF THE FOLLOWING AT TRAQQ’S OPTION:

                        <ul>
                            <li>
                                (I) IN THE CASE OF GOODS;
                                <br />(1) THE REPLACEMENT OF THE GOODS OR THE SUPPLY OF EQUIVALENT GOODS;
                                <br />(2) THE REPAIR OF THE GOODS;
                                <br />(3) THE PAYMENT OF THE COST OF REPLACING THE GOODS OR OF ACQUIRING EQUIVALENT GOODS; OR
                                <br />(4) THE PAYMENT OF THE COST OF HAVING THE GOODS REPAIRED; OR
                            </li>
                            <li>
                                (II) IN THE CASE OF SERVICES;
                                <br />(1) THE SUPPLYING OF THE SERVICES AGAIN; OR
                                <br />(2) THE PAYMENT OF THE COST OF HAVING THE SERVICES SUPPLIED AGAIN.
                            </li>
                        </ul>
                    </li>
                    <li><strong>10.4</strong> BY AGREEING TO THESE TERMS, YOU EXPRESSLY WAIVE THE RIGHT TO PARTICIPATE IN A CLASS ACTION AGAINST TRAQQ AND ANY OF TRAQQ’S SUBSIDIARIES, RELATED COMPANIES, AFFILIATES, AGENTS, EMPLOYEES, PREDECESSORS IN INTEREST, SUCCESSORS AND ASSIGNS. THIS PROVISION SHALL SURVIVE TERMINATION OF THE LICENSE GRANTED TO YOU UNDER THESE TERMS.</li>
                </ul>

                <Heading
                    tag='h4'
                >
                    11. INDEMNIFICATION
                </Heading>

                <Paragraph
                    tag='p'
                >
                    You agree to defend Traqq, its afﬁliates and it's and/or their respective successors and assigns, as well as their respective ofﬁcers, directors, employees, agents, licensors, representatives, operational service providers and suppliers against any and all claims, demand and/or actions, and indemnify and hold Traqq, its afﬁliates and it's and/or their respective successors and assigns, as well as their respective ofﬁcers, directors, employees, agents, representatives, suppliers, licensors and contractors harmless from and against any and all losses, damages, costs and expenses (including attorneys’ fees), resulting from your breach or violation of these Terms, infringement, misappropriation or your violation of the rights of any other party, your violation or non-compliance with any law or regulation, or your alteration to or export of the Service. Traqq reserves the right to assume, at its expense, the exclusive defense and control of any claims or actions and all negotiations for settlement or compromise, and you agree to fully cooperate with Traqq upon its request.
                </Paragraph>

                <Heading
                    tag='h4'
                    id='12'
                >
                    12. LICENSE TERMINATION
                </Heading>

                <ul>
                    <li>
                        <strong>12.1</strong> Traqq may terminate the license granted to you under these Terms immediately by written notice sent to your last email address of record if you are found to be in material breach of any of these Terms and such breach is not remedied within thirty (30) days of notification.
                    </li>
                    <li>
                        <strong>12.1.1</strong> Immediate Ban for System Abuse <br/>
                        If Traqq determines (at its sole discretion) that you or affiliated entities have engaged in fraudulent circumvention of subscription fees, including but not limited to:
                        <ol>
                            <li>
                                <strong>●</strong> Creating multiple accounts
                            </li>
                            <li>
                                <strong>●</strong> Using shell companies or fake credentials
                            </li>
                            <li>
                                <strong>●</strong> Artificially fragmenting operations to evade pricing tiers
                            </li>
                        </ol>
                        <div className="mt-4">Traqq will:</div>
                         <ol>
                            <li>
                                <strong>1.</strong> Permanently terminate all associated accounts without notice or cure period
                            </li>
                            <li>
                                <strong>2.</strong> Block all access (logins, API, integrations)
                            </li>
                            <li>
                                <strong>3.</strong> Forfeit all subscription fees paid by abusive accounts (no refunds)
                            </li>
                        </ol>
                    </li>
                    <li>
                        <strong>12.1.2</strong> Appeals <br/>
                        Banned users may appeal within 14 days of termination by emailing <Link href='mailto:support@traqq.com' mods={ { violet:true } }>support@traqq.com</Link> with evidence disproving the violation. Traqq reserves the right to uphold or reverse bans at its discretion.
                    </li>
                    <li>
                        <strong>12.2</strong> Upon termination of the license granted under these Terms you must immediately cease using the Service and destroy all copies of the software and the Documentation.
                    </li>
                </ul>

                <Heading
                    tag='h4'
                >
                    13. GENERAL
                </Heading>

                <ul>
                    <li>
                        <strong>13.1</strong> Any express statement of a right of Traqq under these Terms is without prejudice to any other rights of Traqq expressly stated in these Terms or existing at law.
                    </li>
                    <li>
                        <strong>13.2</strong> Traqq’s obligations under these Terms are suspended during the continuance of any Force Majeure Event to the extent that those obligations are affected by the Force Majeure Event.
                    </li>
                    <li>
                        <strong>13.3</strong> All notices must be in writing and addressed in the case of notices to Traqq to its email address at <Link href='mailto:support@traqq.com' mods={ { violet:true } }>support@traqq.com</Link>.
                    </li>
                    <li>
                        <strong>13.4</strong> If any provision of these Terms is held to be invalid, illegal or unenforceable, these Terms will continue otherwise in full force and effect apart from such provision which will be taken to be deleted.
                    </li>
                </ul>

                <Heading
                    tag='h4'
                >
                    14. DEFINITIONS AND INTERPRETATION
                </Heading>

                <ul>
                    <li><strong>14.1</strong> Definitions
                        <br />In these Terms, unless the context otherwise requires:
                        <Paragraph
                            tag='p'
                        >
                            "Confidential Information" means the confidential information of Traqq which relates to the subject matter of these Terms and includes information relating to:
                        </Paragraph>

                        <ol type='a'>
                            <li>
                                <strong>a.</strong> the design, specification and content of the Service;
                            </li>
                            <li>
                                <strong>b.</strong> the personnel, policies or business strategies of Traqq;
                            </li>
                            <li>
                                <strong>c.</strong> and the terms upon which the Service is being supplied pursuant to these Terms.
                            </li>
                        </ol>
                    </li>

                    <Paragraph
                        tag='p'
                    >
                        "Force Majeure Event" means any event not within the control of a party whose obligations are affected.
                    </Paragraph>
                    <Paragraph
                        tag='p'
                    >
                        "GST" means goods and services tax or any similar tax.
                    </Paragraph>

                    <li>
                        <strong>14.2</strong> In these Terms, unless the context otherwise requires:
                        <ol type='a'>
                            <li>
                                <strong>a.</strong> headings are for convenience only and do not affect interpretation;
                            </li>
                            <li>
                                <strong>b.</strong> the singular includes the plural and conversely;
                            </li>
                            <li>
                                <strong>c.</strong> the gender includes all genders;
                            </li>
                            <li>
                                <strong>d.</strong> where a word or phrase is defined, its other grammatical forms have a corresponding meaning;
                            </li>
                            <li>
                                <strong>e.</strong> a reference to a person includes any body corporate, unincorporated body or other entity and conversely;
                            </li>
                            <li>
                                <strong>f.</strong> a reference to a clause is to a clause of these Terms; and
                            </li>
                            <li>
                                <strong>g.</strong> all references to $ are to USD (United States dollars).
                            </li>
                        </ol>
                    </li>
                </ul>
            </Container>
        </div>
    </>
);

export default TermsofUse;
